export default __webpack_public_path__ + "static/logo_eco_passport-248a0060e3f54b1aa2ec46f0bebfcda0.png";